import { Component, HostBinding, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AsmService } from '@spartacus/asm/core';
import { AsmUi, TokenTarget } from '@spartacus/asm/root';
import {
  AuthActions,
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
  HttpResponseStatus,
  OAuthLibWrapperService,
  RoutingService,
  StateWithClientAuth,
  User
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { DateTimeProvider, OAuthStorage } from 'angular-oauth2-oidc';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import * as _ from 'underscore';
import { VscaCsAgentAuthService } from '../../facade/vsca-csagent-auth.service';
import { VscaAsmAuthStorageService } from '../../service/vsca-asm-auth-storage.service';
import { VscaAsmComponentService } from '../../service/vsca-asm-component.service';
import { CustomAuthService } from '../../../custom-auth-service.service';

@Component({
  selector: 'vsca-cx-asm-main-ui',
  templateUrl: './vsca-asm-main-ui.component.html',
  styleUrls: ['./vsca-asm-main-ui.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VscaAsmMainUiComponent implements OnInit, OnDestroy {
  protected oAuthLibWrapperService = inject(OAuthLibWrapperService);

  customerSupportAgentLoggedIn$: Observable<boolean>;
  csAgentTokenLoading$: Observable<boolean>;
  customer$: Observable<User | undefined>;
  isCollapsed$: Observable<boolean>;
  protected destroyed$ = new Subject();
  @HostBinding('class.hidden') disabled = false;

  protected startingCustomerSession1 = false;
  baseSiteId: any;
  redirectValue: any;
  isAsmEnabled: any;
  forbiddenResponseStatus = HttpResponseStatus.FORBIDDEN;

  constructor(
    private readonly authService: CustomAuthService,
    private readonly csAgentAuthService: VscaCsAgentAuthService,
    private readonly userService: UserAccountFacade,
    private readonly asmComponentService: VscaAsmComponentService,
    private readonly globalMessageService: GlobalMessageService,
    private readonly routingService: RoutingService,
    private readonly asmService: AsmService,
    private readonly authStorageService: VscaAsmAuthStorageService,
    private readonly baseService: BaseService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store<StateWithClientAuth>,
    private readonly _storage: OAuthStorage,
    protected readonly dateTimeService: DateTimeProvider,
    private readonly baseSiteService: BaseSiteService
  ) {}
  asmSub: Subscription;
  baseSub: Subscription;
  agentSub: Subscription;

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.agentSub = this.csAgentAuthService
      .isCustomerEmulated()
      .subscribe((res) => {
        this.isAsmEnabled = res ? res : false;
      });
    this.csAgentTokenLoading$ = this.csAgentAuthService.getCustomerSupportAgentTokenLoading();
    this.customer$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isLoggedIn) => {
        if (true) {
          this.handleCustomerSessionStartRedirection1();
          return this.userService.get();
        } else {
          return of(undefined);
        }
      })
    );

    this.asmService.getAsmUiState().subscribe((state) => {
      if (state.status === this.forbiddenResponseStatus) {
        this.asmClose();
      }
    });

    this.isCollapsed$ = this.asmService
      .getAsmUiState()
      .pipe(
        map((uiState: AsmUi) =>
          uiState.collapsed === undefined ? false : uiState.collapsed
        )
      );

    let idValue;
    this.activatedRoute.queryParams
      .pipe(
        filter((res) => !_.isEmpty(res)),
        distinctUntilChanged((prev, curr) => prev.id === curr.id)
      )
      .subscribe((res) => {
        if (res.hasOwnProperty('redirect')) {
          this.redirectValue = res.redirect;
          if (res.hasOwnProperty('subSection')) {
            this.redirectValue = `${this.redirectValue}%3FsubSection=${res.subSection}`;
          }
        } else {
          this.redirectValue = '/my-account/account-overview';
        }
        if (res.hasOwnProperty('asm')) {
          idValue = res.id;
          const storageIdToken = localStorage.getItem('id_token');
          if (storageIdToken === null || storageIdToken !== idValue) {
            localStorage.setItem('id_token', idValue);
            if (idValue != null) {
              this.baseService
                .post(`/authenticate/token`, {
                  id: idValue,
                  client_id: 'mobile_android',
                })
                .subscribe({
                  next: (res) => {
                    this.performAuthToken(res);
                  },
                  error: (err) => {
                    this.clearTokenLocally();
                  },
                });
            }
          } else {
            const storageIdToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
            if (storageIdToken) {
              this.performAuthToken(storageIdToken.token);
            }
          }
        }
      });
  }
  performAuthToken(tokenDetails:any) : void {
    this.authStorageService.switchTokenTargetToCSAgent();
    this.authStorageService.setToken(tokenDetails);
    this.authStorageService.setTokenTarget(TokenTarget.CSAgent);
    this.authStorageService.setEmulatedUserToken(tokenDetails);
    this.storeAccessTokenResponse(
      tokenDetails.access_token,
      tokenDetails.expiration,
      tokenDetails.refresh_token,
      tokenDetails.scope
    );
    localStorage.setItem(
      'spartacus⚿⚿asm',
      '{"ui":{"collapsed":false},"tokenTarget":"CSAgent"}'
    );
    this.store.dispatch(new AuthActions.Login());
    this.customerSupportAgentLoggedIn$ =
    this.csAgentAuthService.isCustomerSupportAgentLoggedIn();
    this.csAgentTokenLoading$ = of(false);
  }

  clearTokenLocally() : void {
    localStorage.removeItem('id_token');
    localStorage.removeItem('spartacus⚿⚿auth');
  }

  ngOnDestroy(): void {
    this.asmSub?.unsubscribe();
    this.baseSub?.unsubscribe();
    this.agentSub?.unsubscribe();
  }
  protected storeAccessTokenResponse(
    accessToken: string,
    expiresIn: Date,
    refreshToken: string,
    grantedScopes: String,
    customParameters?: Map<string, string>
  ): void {
    this._storage.setItem('access_token', accessToken);
    if (grantedScopes && !Array.isArray(grantedScopes)) {
      this._storage.setItem(
        'granted_scopes',
        JSON.stringify(grantedScopes.split(' '))
      );
    } else if (grantedScopes && Array.isArray(grantedScopes)) {
      this._storage.setItem('granted_scopes', JSON.stringify(grantedScopes));
    }

    this._storage.setItem(
      'access_token_stored_at',
      '' + this.dateTimeService.now()
    );

    this._storage.setItem('expires_at', '' + expiresIn);

    if (refreshToken) {
      this._storage.setItem('refresh_token', refreshToken);
    }
    if (customParameters) {
      customParameters.forEach((value: string, key: string) => {
        this._storage.setItem(key, value);
      });
    }
  }

  protected handleCustomerSessionStartRedirection1(): void {
    this.asmSub = this.asmComponentService
      .isCustomerEmulationSessionInProgress()
      .pipe(take(1))
      .subscribe((isCustomerEmulated) => {
        if (this.startingCustomerSession1 && isCustomerEmulated) {
          this.startingCustomerSession1 = false;
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        }
      });
  }

  startCustomerEmulationSession({ customerId }: { customerId?: string }): void {
    if (customerId) {
      this.csAgentAuthService.startCustomerEmulationSession(customerId);
      this.startingCustomerSession1 = true;
      this.routingService.goByUrl(this.redirectValue);
    } else {
      this.globalMessageService.add(
        { key: 'asm.error.noCustomerId' },
        GlobalMessageType.MSG_TYPE_ERROR
      );
    }
  }

  goByUrl(url) {
    this.routingService.go(url);
  }
  asmClose() {
    this.routingService.go('/homepage')
      .then(() => {
        this.asmComponentService.logoutCustomerSupportAgentAndCustomer();
        this.hideUi();
        this.asmService.updateAsmUiState({ status: undefined });
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = window.location.origin + window.location.pathname;

      });
  }

  hideUi(): void {
    this.disabled = true;
    this.asmComponentService.unload();
    this.oAuthLibWrapperService.refreshAuthConfig();
    this.authService.updateIsUsingASMClient(false);
  }
}
